var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AuthenticationContext from 'adal-angular';
import { TelemetryEvents } from '@employee-experience/common/lib/TelemetryEvents';
export class ADALClient {
    constructor(options, telemetryClient) {
        this.authContext = new AuthenticationContext(Object.assign({ cacheLocation: 'localStorage', redirectUri: window.location.origin }, options));
        this.authContext.handleWindowCallback();
        this.telemetryClient = telemetryClient;
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.telemetryClient.trackTrace({
                    message: TelemetryEvents.UserLogInRequested,
                });
                try {
                    this.authContext.login();
                    resolve();
                }
                catch (ex) {
                    this.telemetryClient.trackTrace({
                        message: TelemetryEvents.UserLoginFailed,
                    });
                    reject(ex);
                }
            });
        });
    }
    logOut() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.telemetryClient.trackTrace({
                    message: TelemetryEvents.UserLogOutRequested,
                });
                try {
                    this.authContext.logOut();
                    resolve();
                }
                catch (ex) {
                    this.telemetryClient.trackTrace({
                        message: TelemetryEvents.UserLogOutFailed,
                    });
                    reject(ex);
                }
            });
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    const user = this.authContext.getCachedUser();
                    if (!user)
                        return resolve(null);
                    resolve({
                        id: user.userName,
                        email: user.userName,
                        name: user.profile ? user.profile.name : '',
                    });
                }
                catch (ex) {
                    reject(ex);
                }
            });
        });
    }
    getUserId() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const user = yield this.getUser();
                    resolve(user ? user.id : null);
                }
                catch (ex) {
                    reject(ex);
                }
            }));
        });
    }
    isLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    resolve((yield this.getUser()) !== null);
                }
                catch (ex) {
                    reject(ex);
                }
            }));
        });
    }
    acquireToken(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.authContext.acquireToken(resource, (error, token) => {
                    if (error) {
                        this.telemetryClient.trackTrace({
                            message: TelemetryEvents.AcquireTokenFailed,
                            properties: {
                                resource,
                            },
                        });
                        this.telemetryClient.trackException({
                            exception: new Error(error),
                            properties: {
                                resource,
                            },
                        });
                        reject(error);
                        return;
                    }
                    resolve(token);
                });
            });
        });
    }
}
//# sourceMappingURL=ADALClient.js.map